import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import { ITaxonomyGroup } from 'taxonomy/types';

export const getTaxonomyGroups = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<ITaxonomyGroup>> => {
  const { data } = await partfinitiClient.get(
    `/taxonomy/group-list/groups?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<ITaxonomyGroup>(data.data, data.records_filtered);
};
